import SEOHead from '../../components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import Booking from './components/Booking';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "name": "Ecomez",
        "description": "Professional cleaning and maintenance service for homes, offices and small businesses in Cumberland, Portland, and Westbrook",
        "image": "https://public.readdy.ai/ai/img_res/dc71f971667036df8a57b058bd90f420.jpg",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Cumberland",
          "addressRegion": "ME",
          "postalCode": "04021",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "43.7970",
          "longitude": "-70.2568"
        },
        "areaServed": [
          {
            "@type": "City",
            "name": "Cumberland"
          },
          {
            "@type": "City",
            "name": "Portland"
          },
          {
            "@type": "City",
            "name": "Westbrook"
          },
          {
            "@type": "City",
            "name": "South Portland"
          },
          {
            "@type": "City",
            "name": "Scarborough"
          },
          {
            "@type": "City",
            "name": "Gorham"
          }
        ],
        "priceRange": "$$",
        "telephone": "+1-207-650-8754",
        "url": typeof window !== 'undefined' ? window.location.origin : '',
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            "opens": "07:00",
            "closes": "20:00"
          }
        ],
        "sameAs": [
          "https://facebook.com",
          "https://instagram.com",
          "https://twitter.com"
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What types of cleaning services do you offer in Westbrook and Portland?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ecomez offers a complete range of cleaning services: residential cleaning for homes, commercial cleaning for offices and small businesses, regular cleaning (daily, weekly, monthly), one-time interventions, and specialized services such as window, carpet and rug cleaning."
            }
          },
          {
            "@type": "Question",
            "name": "Do you use eco-friendly products?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, absolutely! We primarily use eco-friendly and non-toxic cleaning products that are safe for your family, pets and the environment. We can also use your own products if you wish."
            }
          },
          {
            "@type": "Question",
            "name": "How do I get a quote for a cleaning service?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can request a free quote by filling out our contact form on this page, calling us directly, or sending us an email. We will respond quickly with a detailed estimate tailored to your specific needs."
            }
          },
          {
            "@type": "Question",
            "name": "Are your employees insured and verified?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, all our employees are fully insured, bonded and have passed thorough background checks. We take security and trust very seriously to give you complete peace of mind."
            }
          },
          {
            "@type": "Question",
            "name": "What are your service hours?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We offer flexible hours to fit your schedule. We are available 7 days a week, including evenings and weekends. We can intervene before or after your work hours to minimize disruptions."
            }
          },
          {
            "@type": "Question",
            "name": "What happens if I am not satisfied with the cleaning?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Your satisfaction is our priority. If you are not completely satisfied with our service, contact us within 24 hours and we will come back for free to correct any issues. That's our 100% satisfaction guarantee."
            }
          },
          {
            "@type": "Question",
            "name": "Do I need to provide equipment and cleaning products?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "No, we bring all our own professional equipment and cleaning products. You don't need to provide anything. However, if you prefer us to use specific products, we can accommodate this request."
            }
          },
          {
            "@type": "Question",
            "name": "Do you service areas outside Westbrook and Portland?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we primarily serve Westbrook and Portland, but we also service surrounding areas such as South Portland, Scarborough and Gorham. Contact us to check if we cover your area."
            }
          }
        ]
      },
      {
        "@type": "Service",
        "serviceType": "House Cleaning",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Ecomez"
        },
        "areaServed": {
          "@type": "State",
          "name": "Maine"
        }
      },
      {
        "@type": "Service",
        "serviceType": "Office Cleaning",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Ecomez"
        },
        "areaServed": {
          "@type": "State",
          "name": "Maine"
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead structuredData={structuredData} />
      <Header />
      <main>
        <Hero />
        <Booking />
        <Services />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}